module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-column": ""
    }
  }, [_c('app-toolbar'), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-row": ""
    }
  }, [_c('device-connection', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentOption === 'DeviceConnection'),
      expression: "currentOption === 'DeviceConnection'"
    }]
  }), _vm._v(" "), _c('test-and-parameters', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentOption === 'TestAndParameters'),
      expression: "currentOption === 'TestAndParameters'"
    }]
  }), _vm._v(" "), _c('collect-data', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.currentOption === 'CollectData'),
      expression: "currentOption === 'CollectData'"
    }]
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bd26cd6c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 167
// module chunks = 1